import { LitElement } from 'lit';

import { ConfigurationService, PrintProofReviewDto } from '@/api-sdk';

export const openPrintProofDialog = (element: LitElement) => {
  element.dispatchEvent(new CustomEvent('open-print-proof-dialog'));
};

export const handlePrintProofReview = async (
  uuid: string,
  reviewData: PrintProofReviewDto,
  element: LitElement,
  storeCode: string,
) => {
  try {
    await ConfigurationService.putUpdatePrintProofReview({
      uuid: uuid,
      requestBody: reviewData,
      storeCode: storeCode,
    });

    element.dispatchEvent(
      new CustomEvent('print-proof-review-submitted', { composed: true }),
    );
  } catch (error) {
    console.error(error);
  }
};
